import React, { useContext, useCallback, useState } from 'react';
import { Slider, Box, InputLabel } from '@material-ui/core';

import { ConfigContext } from '../config';

export const MinMaxField = ({ id, label, min, max, ...props }) => {
  const { useConfig, setConfig } = useContext(ConfigContext);
  const minValue = useConfig(`${id}.min`);
  const maxValue = useConfig(`${id}.max`);
  const [tempValue, setTempValue] = useState([minValue, maxValue]);

  const handleTemporaryChange = useCallback((event, value) => setTempValue(value), [setTempValue]);

  const handleChange = useCallback(
    (event, value) => {
      setConfig(id, {
        min: value[0],
        max: value[1],
      });
      setTempValue(value);
    },
    [id, setConfig, setTempValue],
  );

  return (
    <Box flex={1} pt={1}>
      <InputLabel shrink id={`${id}-label`} margin="dense">
        {label}
      </InputLabel>
      <Slider
        value={tempValue}
        onChange={handleTemporaryChange}
        onChangeCommitted={handleChange}
        min={min}
        max={max}
        step={1}
        valueLabelDisplay="auto"
        aria-labelledby={`${id}-label`}
        style={{ marginTop: 0, marginLeft: '0.25rem', marginRight: '0.25rem', marginBottom: 0 }}
        {...props}
      />
    </Box>
  );
};

export default MinMaxField;
